/**
 * Platform Detection Utility
 * Detects whether app is running on iOS, Android, or Web
 */

import { Capacitor } from '@capacitor/core';

export type Platform = 'ios' | 'android' | 'web';

/**
 * Get the current platform
 */
export function getPlatform(): Platform {
  return Capacitor.getPlatform() as Platform;
}

/**
 * Check if running as a native app (iOS or Android)
 */
export function isNative(): boolean {
  return Capacitor.isNativePlatform();
}

/**
 * Check if running on iOS
 */
export function isIOS(): boolean {
  return getPlatform() === 'ios';
}

/**
 * Check if running on Android
 */
export function isAndroid(): boolean {
  return getPlatform() === 'android';
}

/**
 * Check if running on web
 */
export function isWeb(): boolean {
  return getPlatform() === 'web';
}

/**
 * Get platform-specific value
 */
export function platformSelect<T>(options: {
  ios?: T;
  android?: T;
  web: T;
}): T {
  const platform = getPlatform();
  
  if (platform === 'ios' && options.ios !== undefined) {
    return options.ios;
  }
  
  if (platform === 'android' && options.android !== undefined) {
    return options.android;
  }
  
  return options.web;
}

